<template lang="pug">
  .pagination-row
    b-button.mr-1(size="sm", variant="link", :disabled="loading || !hasPreviousPage", @click="$emit('click', currentPage - 1)")
      chevron-left-icon
    b-spinner(small, variant="primary", v-if="loading" )
    div(v-else) {{currentPage}} de {{totalPages}}
    b-button.ml-1(size="sm", variant="link", :disabled="loading || !hasNextPage", @click="$emit('click', currentPage + 1)")
      chevron-right-icon
</template>

<script>
export default {
  name: "Pagination",
  data: () => {
    return {

    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    hasNextPage: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 0
    },
    totalPages: {
      type: Number,
      default: 0
    },
    align: {
      type: String,
      default: 'end'
    },
  },
  computed: {
    hasPreviousPage () {
      return this.currentPage > 1
    },
  },
}
</script>

<style scoped>
.pagination-row {
  display: flex;
  justify-content: right;
  align-items: center;
}
</style>

